import { HeroSection } from "@/components/HeroSection";
import { StagesSection } from "@/components/StagesSection";
import { ResourcesSection } from "@/components/ResourcesSection";
import { ToolsSection } from "@/components/ToolsSection";
import { LatestArticles } from "@/components/LatestArticles";
import { motion } from "framer-motion";
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";

const Index = () => {
  const location = useLocation();
  const mounted = useRef(false);

  useEffect(() => {
    if (mounted.current) {
      if (location.state?.scrollToTools) {
        document.getElementById('tools')?.scrollIntoView({ behavior: 'smooth' });
      } else if (location.state?.scrollToResources) {
        document.getElementById('resources')?.scrollIntoView({ behavior: 'smooth' });
      }
    }
    mounted.current = true;
  }, [location]);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
      className="bg-white"
    >
      <Helmet>
        <title>Twin Flame Journey - Spiritual Growth & Connection</title>
        <meta name="description" content="Explore the profound journey of twin flame connections, spiritual growth, and self-discovery. Find guidance, tools, and resources for your spiritual path." />
      </Helmet>
      
      <HeroSection />
      <ToolsSection />
      <LatestArticles />
      <StagesSection />
      <ResourcesSection />
    </motion.div>
  );
};

export default Index;